<template>
  <div v-if="!loading">
    <h1 class="main-header">
      <translate translate-context="event_owners" :translate-params="{id: event_owner.id, name: event_owner.company_name}">Edit Event Owner  #%{id} - %{name}</translate>
    </h1>
    <Form :data="event_owner" @save="onSave" :save_text="$pgettext('form','Save')" edit/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RecordNotFound, SuccessNotification} from "@/domain/core/exception/exceptions";
import Form from "@/domain/event_owner/components/Form.vue";

export default {
  name: 'EditEventOwner',
  components: {Form},
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchConfig({type: 'event_owner', id: this.$route.params.id}),
        this.fetchEventOwner(this.$route.params.id)
      ])
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'event_owner.list'})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('eventOwner', [
      'event_owner',
    ]),
  },
  methods: {
    ...mapActions('eventOwner', [
      'fetchEventOwner',
      'updateEventOwner',
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    async onSave(data) {
      await this.updateEventOwner({id: this.event_owner.id,data: data})
      await this.$router.push({name: 'event_owner.list'})
      throw new SuccessNotification(this.$pgettext('event_owner', 'Event Owner updated!'))
    }
  }
}
</script>

<style scoped>

</style>
